// extracted by mini-css-extract-plugin
export default {"section":"src-pages-Order-Components-SalesChannel-css-module__section--KtZEB","formItem":"src-pages-Order-Components-SalesChannel-css-module__formItem--y-5Mr"};